import { useEffect } from 'react';

export default function usePageMeta(title, canonicalUrl) {
  useEffect(() => {
    // Only run DOM operations in a browser environment
    if (typeof document === 'undefined') {
      return;
    }

    if (title) {
      document.title = title;
    }

    if (canonicalUrl) {
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      // Ensure we set a string value and avoid throwing on unexpected input
      try {
        link.setAttribute('href', String(canonicalUrl));
      } catch (e) {
        // ignore invalid values for href
      }
    }
  }, [title, canonicalUrl]);
}


